// extracted by mini-css-extract-plugin
module.exports = {"primeWrap":"__7NJ_2Lvb","visible":"__8yY4i_97"};